import { Button, FormControl, FormLabel, Input } from '@chakra-ui/react';
import { Form, useFormikContext } from 'formik';
import React from 'react';
import { localise } from '../../../../services/lang/lang';
import ModalButtonContainer from '../../Modal/ModalButtonContainer';
import { FormContainer } from '../../Form/FormContainer';
import LocationPositionField from './LocationPositionField';
import FormFieldErrors from '../../FormFieldErrors/FormFieldErrors';
import MaxLengthInputControl from '../../Form/MaxLengthInputControl';
import { useUnsavedChanges } from '../../UnsavedChanges/UnsavedChangesProvider';
import { useTrackUnsavedChanges } from '../../UnsavedChanges/useTrackUnsavedChanges';
const MAX_LENGTH = 50;
const EditLocationForm = ({ onClose, canEdit, roomPositions }) => {
    const { handleSubmit, values, errors, handleChange, setFieldValue, dirty, isSubmitting, resetForm, } = useFormikContext();
    const onFloorUpdated = (floorNumber) => {
        setFieldValue('floor_number', floorNumber);
    };
    const onRoomPositionsUpdated = (selectedRoomPositions) => {
        setFieldValue('room_positions', selectedRoomPositions);
    };
    const { attemptNavigate } = useUnsavedChanges();
    useTrackUnsavedChanges(dirty);
    const doSubmit = () => {
        resetForm({ values });
        handleSubmit();
    };
    return (React.createElement(Form, null,
        React.createElement(FormContainer, { "data-testid": "edit_location_form" },
            React.createElement(MaxLengthInputControl, { isInvalid: !!errors.name, length: values.name?.length, isDisabled: !canEdit, label: localise('DISPLAY_NAME'), maxLength: MAX_LENGTH },
                React.createElement(Input, { w: "full", variant: "filled", maxLength: MAX_LENGTH, autoComplete: "off", type: "text", onChange: handleChange, placeholder: localise('NONE_ADDED'), value: values.name ?? '', name: "name" }),
                React.createElement(FormFieldErrors, { errors: errors.name })),
            React.createElement(MaxLengthInputControl, { isInvalid: !!errors.dimensions, length: values.dimensions?.length, isDisabled: !canEdit, label: localise('DIMENSIONS'), maxLength: MAX_LENGTH },
                React.createElement(Input, { w: "full", variant: "filled", maxLength: MAX_LENGTH, onChange: handleChange, placeholder: localise('NONE_ADDED'), value: values.dimensions ?? '', name: "dimensions" }),
                React.createElement(FormFieldErrors, { errors: errors.dimensions })),
            React.createElement(FormControl, { isDisabled: !canEdit },
                React.createElement(FormLabel, { "aria-label": localise('POSITION') }, localise('POSITION')),
                React.createElement(LocationPositionField, { isDisabled: !canEdit, onFloorUpdated: onFloorUpdated, onRoomPositionsUpdated: onRoomPositionsUpdated, roomPositionOptions: roomPositions, floorNumber: values.floor_number, selectedRoomPositions: values.room_positions })),
            React.createElement(ModalButtonContainer, null,
                React.createElement(Button, { onClick: () => {
                        attemptNavigate(onClose);
                    }, variant: "secondary" }, localise('CANCEL')),
                React.createElement(Button, { isDisabled: !canEdit || !dirty || isSubmitting, onClick: doSubmit, variant: "primary" }, localise('SAVE'))))));
};
export default EditLocationForm;
